const config = {
  APP_NAME: 'Aqua Mail',
  APP_DOMAIN: "", // leave it empty to automatically determine the domain
  API_URL: "", // leave it empty to use the app domain
  ANALYTICS_URL: 'https://cc-api-st.aldoo.com',
  SUPPORT_CHAT_API: "",
  CMS_STATIC_URL: "",

  // Encryption configuration
  ENCRYPTION_ENABLED: false, // Start disabled for gradual rollout (✅ tested working)
  INFLIGHT_ENCRYPTION_KEY: "", // Same key as backend

  // Talk with the platform users
  PLATFORM_API_URL: 'http://localhost:7040',
  // Optional: used only by SSR (server-side) to bypass the public domain
  // (and the CDN) and reach the REST API over loopback. Leave empty in
  // local/dev where PLATFORM_API_URL already points at localhost. In
  // production, set to e.g. 'http://127.0.0.1:<API_PORT>' via deployment.js.
  INTERNAL_API_URL: '',
  PLATFORM_API_VERSION: 'v1',
  STRIPE_API_KEY: 'pk_test_51K9Y5AE2k8zaBmhTXyhlWwzoSOF9aar1YfqKE27h9XuXpQKOEeuuVja20H3mQBewaDjBRw9Pr7d7qJ6jdnyEmzGQ0069k8akt9',

  // GTM Integration
  GTM_ID: "", // replace with your GTM container ID

  FACEBOOK_PIXEL: false,
  FACEBOOK_OPTIONS: "",
  TRACKING_GDPR: false,
  GOOGLE_ANALYTICS_ID: "",

  //If true will print additional information on api calls that respond with an error object
  API_DIAGNOSTICS: false,

  // CMS Prefetching configuration
  CMS_PREFETCH: true, // Enable/disable CMS prefetching at build time

}

export default config